import { actions as integrationsActions } from 'react/api/actions/integrations';
import { fromJS, Map } from 'immutable';

const initialState = fromJS({
  integrations: [],
  integrationsLogsPage: {},
  eventNotifierSSEIsOpen: false,
  isLoadingIntegrations: false,
  isModalConfirmRetryOpen: false,
  connectionState: {
    isConnecting: false,
    success: null,
    error: null
  },
  disableState: {
    isDisabling: false,
    success: null,
    error: null
  },
  retryLogsState: {
    logsToRetry: [],
    isRetrying: false,
    error: null
  }
});

export default (state = initialState, action) => {
  switch (action.type) {
    case integrationsActions.setConnectionState: {
      const { isConnecting, success, error } = action.payload;

      return state.set('connectionState', { isConnecting, success, error });
    }
    case integrationsActions.setDisableState: {
      const { isDisabling, success, error } = action.payload;

      return state.set('disableState', { isDisabling, success, error });
    }
    case integrationsActions.setIsLoadingIntegrations: {
      const { isLoadingIntegrations } = action.payload;

      return state.set('isLoadingIntegrations', isLoadingIntegrations);
    }
    case integrationsActions.setRetryLogsState: {
      const { logsToRetry, isRetrying, error } = action.payload;

      return state.set('retryLogsState', fromJS({ logsToRetry, isRetrying, error }));
    }
    case integrationsActions.addIntegration: {
      const integrationData = action.payload;

      const findIntegration = state
        .get("integrations")
        .findIndex(
          (integration) => {
            const data = Map.isMap(integration) ? integration : fromJS(integration);
            return data.get("id") === integrationData.id ||
              data.getIn(["integration", "name"]) === integrationData.integration.name;
          }
        );

      const updateIntegrations = (integrations) => integrations?.size ?
        integrations.concat(integrationData) : fromJS([integrationData]);

      return findIntegration === -1 ? state.updateIn(['integrations'], updateIntegrations) : state;
    }
    case integrationsActions.updateIntegrations: {
      const { integrations } = action.payload;

      return state.set('integrations', fromJS(integrations));
    }
    case integrationsActions.updateSingleIntegration: {
      const integrationData = action.payload;

      const integrationToUpdateIndex = state
        .get("integrations")
        .findIndex(
          (integration) =>
            integration.get("id") === integrationData.id ||
            integration.getIn(["integration", "name"]) === integrationData.integration.name
        );

      return integrationToUpdateIndex > -1 ? state.mergeIn(
        ['integrations', integrationToUpdateIndex],
        integrationData
      ) : state;
    }
    case integrationsActions.updateIntegrationLogs: {
      const { integrationId, integrationLogs, shouldClearBeforeUpdateLogs } = action.payload;

      const updateIntegrationLogs = (actualLogs) => actualLogs && !shouldClearBeforeUpdateLogs ?
        actualLogs.concat(integrationLogs) : fromJS(integrationLogs);

      return state.updateIn(['integrationsLogsPage', integrationId, 'logs'], updateIntegrationLogs);
    }
    case integrationsActions.clearIntegrationLogs: {
      const { integrationId } = action.payload;

      return state.setIn(['integrationsLogsPage', integrationId, 'logs'], fromJS([]));
    }
    case integrationsActions.toggleRetryIntegrationLogsConfirmModal: {
      const isModalConfirmRetryOpen = state.get('isModalConfirmRetryOpen');

      return state.set('isModalConfirmRetryOpen', !isModalConfirmRetryOpen);
    }
    case integrationsActions.toggleLogDetailsModal: {
      const { integrationId, logDetailsData, isModalLogDetailsOpen } = action.payload;

      if (isModalLogDetailsOpen)
        return state
          .setIn(['integrationsLogsPage', integrationId, 'isModalLogDetailsOpen'], isModalLogDetailsOpen)
          .setIn(['integrationsLogsPage', integrationId, 'modalLogDetailsData'], fromJS(logDetailsData));
      else
        return state
          .setIn(['integrationsLogsPage', integrationId, 'isModalLogDetailsOpen'], isModalLogDetailsOpen)
          .setIn(['integrationsLogsPage', integrationId, 'modalLogDetailsData'], fromJS({}));
    }
    case integrationsActions.updateEventNotifierSSEStatus: {
      const status = action.payload;
      return state.set('eventNotifierSSEIsOpen', status);
    }
    default:
      return state;
  }
};
